module.exports = __webpack_public_path__ + "img/icon6.24754300.png";